import React from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import StatusBadge from "./StatusBadge";
import {
  formatDateTime,
  fosDisplayLabel,
  fosHasChip,
  statusAccentColor,
} from "./partnersMobileUtils";
import css from "./partnersMobile.module.css";

// Chip follows the desktop FoSID column: "Disabled" when the login is
// disabled, otherwise the approval status chip (pending / approved / ...).
export default function FosCard({ row, onOpen, onAction }) {
  const showChip = fosHasChip(row);
  const accent = statusAccentColor(
    showChip ? { status: row.approvalStatus, disabled: row.isDisabled } : {}
  );
  const idLabel = fosDisplayLabel(row);

  return (
    <div className={css.card} style={{ borderLeftColor: accent }}>
      <div className={css.cardHeader}>
        <span className={css.cardId}>{idLabel}</span>
        {showChip && (
          <StatusBadge status={row.approvalStatus} disabled={row.isDisabled} />
        )}
        <span className={css.cardHeaderSpacer} />
        <button
          type="button"
          className={css.kebab}
          aria-label={`Actions for ${idLabel}`}
          onClick={(e) => {
            e.stopPropagation();
            onAction(row);
          }}
        >
          <MoreVertIcon sx={{ fontSize: 20 }} />
        </button>
      </div>

      <button type="button" className={css.cardBody} onClick={() => onOpen(row)}>
        <div className={css.cardTitle}>{row.name || "—"}</div>
        <div className={css.kv}>
          <span className={css.kvKey}>CP</span>
          <span className={css.kvValue}>{row.cpName || "—"}</span>
        </div>
        <div className={css.cardFooter}>
          <div>Created {formatDateTime(row.createdAt)}</div>
          <div>Updated {formatDateTime(row.lastUpdated)}</div>
        </div>
      </button>
    </div>
  );
}
